(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PricingDetailController', PricingDetailController);

    PricingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pricing', 'Contract'];

    function PricingDetailController($scope, $rootScope, $stateParams, previousState, entity, Pricing, Contract) {
        var vm = this;

        vm.pricing = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:pricingUpdate', function(event, result) {
            vm.pricing = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
